
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28 8l-9-8H3a3 3 0 00-3 3v26a3 3 0 003 3h22a3 3 0 003-3V8z","fill":"#C4C4C4"}}),_c('path',{attrs:{"d":"M19 6V0l9 8h-7a2 2 0 01-2-2z","fill":"#161616","fill-opacity":".24"}})])
          )
        }
      }
    